/* HORUS UK 24.set.2026: copiado da Horus Fashion (.com).
   Grava a data no atributo de carrinho "Delivery deadline" (mesma chave da .com - nao traduzir). */
(function () {
  if (window.__hfCartDeadline) return;
  window.__hfCartDeadline = true;

  var KEY = 'Delivery deadline';
  var known = null;
  var timer = null;
  var inFlight = false;

  function root() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function post(value) {
    var attrs = {};
    attrs[KEY] = value || '';
    inFlight = true;
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        known = (cart && cart.attributes && cart.attributes[KEY]) || '';
        return cart;
      })
      .catch(function (e) { if (window.console) console.warn('[cart-deadline] falha ao salvar', e); })
      .then(function () { inFlight = false; });
  }

  function save(value) {
    known = value || '';
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { post(value); }, 250);
  }

  function paint(value) {
    var has = !!value;
    document.querySelectorAll('[data-deadline-widget]').forEach(function (w) {
      var box = w.querySelector('[data-deadline-toggle]');
      var panel = w.querySelector('[data-deadline-panel]');
      var input = w.querySelector('[data-deadline-input]');
      if (box) box.checked = has;
      if (panel) panel.hidden = !has;
      if (input && input.value !== (value || '')) input.value = value || '';
    });
  }

  function hydrate(widget) {
    if (known !== null) { paint(known); return; }
    var input = widget.querySelector('[data-deadline-input]');
    if (input && input.value) { known = input.value; paint(known); return; }
    if (inFlight) return;
    fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        known = (cart && cart.attributes && cart.attributes[KEY]) || '';
        paint(known);
      })
      .catch(function () { known = ''; });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.matches('[data-deadline-toggle]')) {
      var w = t.closest('[data-deadline-widget]');
      if (!w) return;
      if (t.checked) {
        var panel = w.querySelector('[data-deadline-panel]');
        if (panel) panel.hidden = false;
        paint(known || '');
        var box = w.querySelector('[data-deadline-toggle]');
        if (box) box.checked = true;
        var p2 = w.querySelector('[data-deadline-panel]');
        if (p2) p2.hidden = false;
      } else {
        paint('');
        save('');
      }
      return;
    }
    if (t.matches('[data-deadline-input]')) {
      paint(t.value);
      save(t.value);
    }
  });

  function boot() {
    var first = document.querySelector('[data-deadline-widget]');
    if (first) hydrate(first);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('[data-deadline-widget]')) { hydrate(n); return; }
        if (n.querySelector && n.querySelector('[data-deadline-widget]')) { hydrate(n.querySelector('[data-deadline-widget]')); return; }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
